import couponsEn from './coupons/en.json';
import couponsZhHant from './coupons/zh-Hant.json';
import couponsVi from './coupons/vi.json';
import couponsTh from './coupons/th.json';

export default {
  en: couponsEn,
  'zh-Hant': couponsZhHant,
  vi: couponsVi,
  th: couponsTh,
};
